<div *ngIf="imageCard" class="center-card">
    <img (error)="onImgError($event)" [src]="cleanURL(imageCard)" height="614" width="421">
  </div>
  <div *ngIf="image !=''" class="center-card">
    <img [src]="cleanURL(image)" class='oversize'>
  </div>